/* src/components/tis-create-update-question-modal/tis-create-update-question-modal.component.scss */
:host {
  display: block;
}
.answers {
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
}
.answer {
  display: flex;
  align-items: center;
  column-gap: 1rem;
}
.answer__input {
  width: 100%;
}
.add-answer-button {
  margin-top: 0.5rem;
}
.horizontal-container {
  display: flex;
  column-gap: 0.5rem;
  align-items: center;
}
.horizontal-container__child--grow {
  flex: 1;
}
/*# sourceMappingURL=tis-create-update-question-modal.component-Z275LSTJ.css.map */
